import React from 'react';

class SvgMedium extends React.Component {
  state = {
    fillColor: '#cccccc'
  };

  hoverOn() {
    this.setState({ fillColor: '#D22136' });
  }

  hoverOff() {
    this.setState({ fillColor: '#cccccc' });
  }

  render() {
    return (
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 195 195"
        onMouseEnter={() => this.hoverOn()}
        onMouseLeave={() => this.hoverOff()}
        {...this.props}
      >
        <g fillRule="nonzero" fill="none">
          <path fill={this.state.fillColor} d="M0 0h195v195H0z" />
          <path
            d="M46.534 65.216a5.074 5.074 0 0 0-1.651-4.28L32.65 46.2V44h37.98l29.355 64.381L125.795 44H162v2.201l-10.458 10.027a3.057 3.057 0 0 0-1.162 2.935v73.674a3.057 3.057 0 0 0 1.162 2.935l10.213 10.027V148h-51.372v-2.201l10.58-10.272c1.04-1.04 1.04-1.345 1.04-2.934V73.042l-29.417 74.713H88.61L54.362 73.042v50.074a6.908 6.908 0 0 0 1.896 5.747l13.76 16.691v2.201H31v-2.2l13.76-16.692a6.663 6.663 0 0 0 1.774-5.747v-57.9z"
            fill="#222222"
          />
        </g>
      </svg>
    );
  }
}

export default SvgMedium;
